<template>
  <!-- avue使用了important -->
  <el-container
    style="background: white; padding: 0 20px !important; min-height: 900px"
    v-loading="loading"
  >
    <!-- 主体 -->
    <el-main>
      <!-- 合同标题 -->
      <div class="top-title">
        <el-tag style="margin-right: 20px">
          {{
            tool.getDictionaryValue(lifeCycleList, 'dictValue', 'dictKey', contract.lifecycleIndex)
          }}
        </el-tag>
        <div class="name-code">
            <div class="name-code-title">{{ contract.name }}</div>
            <div class="name-code-code">合同编号：{{ contract.code }}</div>
        </div>
        <!-- <el-tag style="margin-right: 20px" type="info">合同名称：{{ contract.name }}</el-tag>
        <el-tag style="margin-right: 20px" type="info">合同编号：{{ contract.code }}</el-tag> -->
      </div>
      <!-- tabs -->
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <!-- 合同信息 tab1 -->
        <el-tab-pane label="合同信息" name="first">
          <el-form label-width="100px" ref="contractForm">
            <el-row>
              <el-col span="12">
                <el-form-item label="项目名称">
                  <el-select class="el-select-wide" v-model="contract.projectId" disabled>
                    <el-option
                      v-for="(item, index) in projectList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="合同类型">
                  <el-select class="el-select-wide" v-model="contract.type" disabled>
                    <el-option
                      v-for="(item, index) in contractTypeList"
                      :key="index"
                      :label="item.dictValue"
                      :value="item.dictKey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
            <el-row>
              <el-col span="12">
                <el-form-item label="合同编号">
                  <el-input disabled v-model="contract.code"></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="合同对象">
                  <el-select class="el-select-wide" v-model="contract.partnerId" disabled>
                    <el-option
                      v-for="(item, index) in partnerList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
            <el-row>
              <el-col span="12">
                <el-form-item label="签订日期">
                  <el-date-picker
                    disabled
                    v-model="contract.signTime"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="收付款类型" prop="paymentType">
                  <el-radio
                    v-for="(item, index) in dictData.paymentTypeList"
                    :key="index"
                    v-model="contract.paymentType"
                    disabled
                    :label="item.dictKey"
                    >{{ item.dictValue }}</el-radio
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
            <el-row>
              <el-col span="12">
                <el-form-item label="生效日期">
                  <el-date-picker
                    disabled
                    v-model="contract.validityPeriodStart"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="有效期至">
                  <el-date-picker
                    disabled
                    v-model="contract.validityPeriodEnd"
                    type="date"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 质保期止 -->
            <el-row>
              <el-col span="12">
                <el-form-item label="质保期止" prop="warrantyPeriodEnd">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="contract.warrantyPeriodEnd"
                    style="width: 100%"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
            <el-row>
              <el-col span="12">
                <el-form-item label="合同金额">
                  <el-input disabled v-model="contract.money" />
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="允许超额">
                  <el-radio v-model="contract.overflowFlag" :label="1" disabled>允许</el-radio>
                  <el-radio v-model="contract.overflowFlag" :label="0" disabled>不允许</el-radio>
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
            <el-row>
              <el-col span="12">
                <el-form-item label="签订部门">
                  <el-input disabled v-model="contract.signDept" />
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="责任人">
                  <el-select class="el-select-wide" v-model="contract.chargeManName" disabled>
                    <!-- <el-option
                      v-for="(item, index) in userTree"
                      :key="index"
                      :label="item.realName"
                      :value="item.id"
                    ></el-option> -->
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
            <el-row>
              <el-col span="24">
                <el-form-item label="备注">
                  <el-input type="textarea" disabled v-model="contract.description"  :autosize="true"/>
                </el-form-item>
              </el-col>
            </el-row>
            <!--  -->
            <el-row>
              <el-form-item label="关联合同">
                <el-table border :data="contract.destIdList">
                  <el-table-column prop="name" label="合同名称"> </el-table-column>
                  <el-table-column prop="code" label="合同编号"> </el-table-column>
                  <el-table-column label="合同对象">
                    <template slot-scope="scope">
                      {{ tool.getDictionaryValue(partnerList, 'name', 'id', scope.row.partnerId) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="合同状态">
                    <template slot-scope="scope">
                      {{
                        tool.getDictionaryValue(
                          lifeCycleList,
                          'dictValue',
                          'dictKey',
                          scope.row.status
                        )
                      }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-row>
            <el-form-item label="合同描述">
              <div
                style="border: 1px solid #eee; padding: 0 10px; color: #c0c4cc; min-height: 60px"
                v-html="contract.content"
              ></div>
            </el-form-item>
            <el-form-item label="合同附件">
              <VUpload
                v-if="contract.fileList && contract.fileList.length"
                :fileList.sync="contract.fileList"
                :disabled="true"
              />
              <div v-else>无附件</div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- 合同收付款 tab2 -->
        <el-tab-pane :label="`合同${contractPaymentTypeLabel}`" name="second">
        <!-- <el-tab-pane :label="`合同收款`" name="second"> -->
          <div class="pan">
            <div class="pan-item">
              <div class="pan-item-content"> {{ tool.money_format_allowvoid(contract.money) }}</div>
              <div class="pan-item-content-title">合同金额</div>

            </div>
            <div class="pan-item">
              <div class="pan-item-content">
                  {{ tool.money_format_allowvoid(statistics.totalPlanAmount) }}
              </div>
               <div class="pan-item-content-title">
                <!-- {{ `计划${contractPaymentTypeLabel}金额` }} -->
                计划结算金额
              </div>
            </div>
            <div class="pan-item">
              <div class="pan-item-content">
                 {{ tool.money_format_allowvoid(statistics.totalPaidAmount) }}
              </div>
              <div class="pan-item-content-title">
                <!-- {{ `${contractPaymentTypeLabel}金额` }} -->
                已结算金额
              </div>
            </div>
            <div class="pan-item">
              <div class="pan-item-content">
                {{ tool.money_format_allowvoid(statistics.totalUnPaidAmount) }}
              </div>
              <div class="pan-item-content-title">
                <!-- {{ `未${contractPaymentTypeLabel}金额` }} -->
                未结算金额
              </div>
            </div>
            <div class="pan-item">
               <el-progress

                  :percentage="((statistics.totalPaidAmount * 100) / contract.money).toFixed(0)"
                  :format="format"
                ></el-progress>
                <div class="pan-item-content" v-if="contract.money === '0' || contract.money === 0">
                暂无进度条
              </div>
              <div class="pan-item-content-title">结算进度</div>







              <!-- <div class="pan-item-content pan-process" v-if="contract.money > 0">
                <el-progress
                  style="width: 128px"

                  :percentage="((statistics.totalPaidAmount * 100) / contract.money).toFixed(2)"
                  :format="format"
                ></el-progress>
              </div>
              <div class="pan-item-content" v-if="contract.money === '0' || contract.money === 0">
                暂无进度条
              </div>
              <div class="pan-item-content-title">进度</div> -->

            </div>
          </div>

          <!-- 收付款dialog -->
          <el-dialog
            :title="contractPaymentTitle"
            :visible.sync="paymentRecordShow"
            append-to-body="true"
            width="40%"
            :close-on-click-modal="false"
            >
            <el-form
              ref="formPayment"
              v-if="paymentRecordShow"
              :rules="formPaymentRules"
              :model="form"
              label-width="140px"
            >
              <el-form-item label="合同名称" prop="name" >
                  <el-row :gutter="24">
                     <el-col :span="18">
                       <div style="display:flex">
                            <el-input v-model="contract.name" disabled></el-input>
                        </div>

                     </el-col>

                  </el-row>
              </el-form-item>
             <!-- <el-form-item label="合同名称" >
                  <el-input v-model="contract.name" disabled></el-input>
                </el-form-item> -->
                <el-form-item label="合同编号" prop="code" >
                 <el-row :gutter="24">
                   <el-col :span="18">
                     <el-input v-model="contract.code" disabled></el-input>
                   </el-col>
                 </el-row>

                </el-form-item>
              <!-- <el-form-item label="合同编号" >
                  <el-input v-model="contract.code" disabled></el-input>
                </el-form-item> -->
                <el-form-item label="供应商名称" prop="partnerName" >
                    <el-row :gutter="24">
                   <el-col :span="18">
                     <el-input v-model="contract.partnerName" disabled></el-input>
                   </el-col>
                  </el-row>
                </el-form-item>
                 <!-- <el-form-item label="供应商名称" >
                  <el-input v-model="contract.partnerName" disabled></el-input>
                </el-form-item> -->
              <!-- <el-form-item :label="`${contractPaymentTypeLabel}金额`" prop="payAmount"> -->
              <el-form-item :label="`结算金额`" prop="payAmount">
                <el-row :gutter="24">
                   <el-col :span="18">
                      <el-input type="number" v-model="form.payAmount"></el-input>
                   </el-col>
                 </el-row>

              </el-form-item>
                <!-- <el-form-item :label="`结算金额`" prop="payAmount">
                <el-input type="number" v-model="form.payAmount"></el-input>
              </el-form-item> -->
              <!-- <el-form-item :label="`${contractPaymentTypeLabel}日期`" prop="payTime"> -->
              <el-form-item :label="`结算日期`" prop="payTime">
                <el-row :gutter="24">
                   <el-col :span="18">
                      <el-date-picker style="width:100%" v-model="form.payTime" type="date" placeholder="选择日期">
                      </el-date-picker>
                   </el-col>
                 </el-row>

              </el-form-item>
                <!-- <el-form-item :label="`结算日期`" prop="payTime">
                      <el-date-picker style="width:100%" v-model="form.payTime" type="date" placeholder="选择日期">
                      </el-date-picker>
              </el-form-item> -->
              <el-form-item label="备注" prop="remark">
                <el-row :gutter="24">
                   <el-col :span="18">
                      <el-input v-model="form.remark" maxlength="200"
                        show-word-limit></el-input>
                   </el-col>
                 </el-row>

              </el-form-item>
              <!-- <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" maxlength="200"
                        show-word-limit></el-input>
              </el-form-item> -->
              <el-form-item label="附件">
                <VUpload :fileList.sync="form.attachList" action="/api/v4ward/oss/customEndpoint/put-file" />
              </el-form-item>
              <el-form-item  style="text-align:right">
                <el-button type="primary" @click="onSubmit" style="margin-right: 20px"
                  >确定</el-button
                >
                <el-button @click="paymentRecordShow = false">取消</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
          <!-- 计划 -->
          <div class="plan">
            <div class="plan-header">
              <div class="plan-header-title">计划</div>
              <!-- <el-tag style="margin-right: 20px">计划</el-tag> -->
              <el-button
                type="primary"
                plain
                size="small"
                v-if="permission"
                @click="addPaymentStage"
                icon="el-icon-plus"
              >
                新增
              </el-button>
            </div>
            <!-- 新增计划dialog -->
            <el-dialog
              :title="paymentStageDialogTitle"
              :visible.sync="paymentStageShow"
              append-to-body="true"
              v-if="paymentStageShow"
              width="40%"
              :close-on-click-modal="false"
            >
              <el-form
                ref="stageForm"
                :rules="stageFormRules"
                :model="stageForm"
                label-width="140px">
                <el-form-item label="合同名称" >
                  <el-input v-model="contract.name" disabled></el-input>
                </el-form-item>
                <el-form-item label="合同编号" >
                  <el-input v-model="contract.code" disabled></el-input>
                </el-form-item>
                 <el-form-item label="供应商名称" >
                  <el-input v-model="contract.partnerName" disabled></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="title">
                  <el-input v-model="stageForm.title"></el-input>
                </el-form-item>
                <el-form-item label="条件" prop="conditions">
                  <el-input v-model="stageForm.conditions"></el-input>
                </el-form-item>
                <!-- <el-form-item :label="`${contractPaymentTypeLabel}金额`" prop="planAmount"> -->
                  <el-form-item :label="`结算金额`" prop="planAmount">
                  <el-input type="number" v-model="stageForm.planAmount"></el-input>
                </el-form-item>
                <!-- <el-form-item :label="`${contractPaymentTypeLabel}时间`" prop="planTime"> -->
                  <el-form-item :label="`结算时间`" prop="planTime">
                  <el-date-picker
                    v-model="stageForm.planTime"
                    type="date"
                    placeholder="选择日期"
                    clearable style="width:100%"
                  ></el-date-picker>
                </el-form-item>
                <!-- <el-form-item :label="`结算日期`" prop="payTime">
                <el-row :gutter="24">
                   <el-col :span="18">
                      <el-date-picker
                    v-model="stageForm.planTime"
                    type="date"
                    placeholder="选择日期"
                    clearable style="width:100%"
                  ></el-date-picker>
                   </el-col>
                 </el-row>

              </el-form-item> -->
                <el-form-item style="text-align:right">
                  <el-button
                    type="primary"
                    @click="handleSavePaymentStage"
                    style="margin-right: 20px"
                    >确定</el-button
                  >
                  <el-button @click="paymentStageShow = false">取消</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <!--  -->
            <el-table :data="paymentStage.records" border style="margin-bottom: 20px" align='center'>
              <el-table-column prop="title" align='center' label="名称"> </el-table-column>
              <el-table-column prop="conditions" align='center' label="条件"> </el-table-column>
              <el-table-column label="日期" align='center'>
                <template slot-scope="scope" style="line-height:46px">
                  <div style="line-height:46px">{{ scope.row.planTime.replace('00:00:00', '') }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="planAmount" label="金额" align="right">
                <template slot-scope="scope">
                  <div>{{tool.money_format_allowvoid(scope.row.planAmount)}}</div>
                </template>
              </el-table-column>
              <el-table-column width="200" v-if="permission" label="操作" >
                <template slot-scope="scope">
                  <div style="display: flex">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="editPaymentStage(scope.row)"
                      icon="el-icon-edit"
                    >
                      编辑
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="delPaymentStage(scope.row)"
                      icon="el-icon-delete"
                    >
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <!-- </div> -->
            </el-table>
            <!-- 分页 -->
            <div style="text-align: right">
              <el-pagination
                v-if="paymentStage.total > 5"
                background
                layout="prev, pager, next , total"
                :total="paymentStage.total"
                @current-change="paymentStagePageChange"
                style="margin-bottom: 20px"
              >
              </el-pagination>
            </div>
            <!--  -->
            <!-- 收款记录/付款记录 -->
            <div class="plan-header">
              <!-- <div class="plan-header-title">{{ contractPaymentTypeLabel }}记录</div> -->
              <div class="plan-header-title">结算记录</div>
              <el-button
                type="primary"
                plain
                size="small"
                @click="addPaymentRecord"
                v-if="permission"
              >
                <i class="el-icon-plus">新增</i>
              </el-button>
            </div>
            <el-table :data="paymentRecord.records" v-loading="paymentRecordLoading" border align='center'>
              <el-table-column prop="payTime" label="日期" align='center'>
                <template slot-scope="scope">
                  <span>{{ scope.row.payTime | showYmd }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="payAmount" label="金额" align="right" >
                <template slot-scope="scope">
                  <span>{{tool.money_format_allowvoid(scope.row.payAmount)  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" align='center'>
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column width="200" label="操作" v-if="permission">
                <template slot-scope="scope">
                  <div style="display: flex">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="collectionRecordEdit(scope.row)"
                      icon="el-icon-edit"
                    >
                      编辑
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="collectionRecordDel(scope.row)"
                      icon="el-icon-delete"
                    >
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="log-pagination">
              <el-pagination
                v-if="paymentRecord.total > 10"
                background
                layout="prev, pager, next , total"
                :total="paymentRecord.total"
                @current-change="paymentRecordPageChange"
              >
              </el-pagination>
              <div class="reminder">温馨提示：合同付款金额以财务金额为准，本系统只做参考</div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 发票记录tab3 -->
        <el-tab-pane label="发票记录" name="third">
          <div class="pan" style="grid-template-columns: repeat(3,1fr);">
            <div class="pan-item" >
              <div class="pan-item-content">
                {{ tool.money_format_allowvoid(invoiceStatistics.totalReceivedAmount )}}
              </div>
              <div class="pan-item-content-title">已收票金额</div>

            </div>
            <div class="pan-item">
              <div class="pan-item-content">
                {{tool.money_format_allowvoid(invoiceStatistics.totalUnReceivedAmount ) }}
              </div>
              <div class="pan-item-content-title">未收票金额</div>

            </div>
            <div class="pan-item">

              <el-progress

                  :percentage="((invoiceStatistics.totalReceivedAmount * 100) / contract.money).toFixed(0)"

                ></el-progress>
                <div class="pan-item-content" v-if="contract.money === '0' || contract.money === 0">
                暂无进度条
              </div>
              <div class="pan-item-content-title">进度</div>
            </div>
            <!-- 新增发票dialog -->
            <el-dialog title="新增发票记录" :visible.sync="invoiceShow" append-to-body="true"
                       :close-on-click-modal="false">
              <el-form
                ref="invoiceForm"
                v-if="invoiceShow"
                :rules="invoiceFormRules"
                :model="invoiceForm"
                label-width="140px"
                :close-on-click-modal="false"
              >
                <el-row>
                  <el-col span="12">
                      <el-form-item label="合同名称" >
                        <el-input v-model="contract.name" disabled></el-input>
                      </el-form-item>
                  </el-col>
                 <el-col span="12">
                      <el-form-item label="合同编号" >
                        <el-input v-model="contract.code" disabled></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="供应商名称" prop="partnerName">
                      <el-input :disabled="true" v-model="invoiceForm.partnerName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="税号" prop="taxNo">
                      <el-input :disabled="true" v-model="invoiceForm.taxNo"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="12">
                    <el-form-item label="发票类型" prop="type">
                      <el-select
                        class="el-select-wide"
                        v-model="invoiceForm.type"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item, index) in dictData.invoiceType"
                          :key="index"
                          :label="item.dictValue"
                          :value="item.dictKey"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="发票金额" prop="amount" style="text-align: right;">
                      <el-input type="number" v-model="invoiceForm.amount"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="12">
                    <el-form-item label="税率" prop="taxRate">
                      <el-select
                        class="el-select-wide"
                        v-model="invoiceForm.taxRate"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item, index) in dictData.taxRateList"
                          :key="index"
                          :label="item.dictValue"
                          :value="item.dictKey"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="发票内容" prop="content">
                      <el-input v-model="invoiceForm.content"   maxlength="200"
                        show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="12">
                    <el-form-item label="发票号码" prop="invoiceNo">
                      <el-input v-model="invoiceForm.invoiceNo"   maxlength="50"
                        show-word-limit></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col span="12">
                    <el-form-item label="发票日期" prop="invoiceTime">
                      <el-date-picker
                        v-model="invoiceForm.invoiceTime"
                        type="date"
                        placeholder="选择日期"
                        style="width: 100%"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col span="24">
                    <el-form-item label="备注" prop="remark">
                      <el-input
                        type="textarea"
                        maxlength="200"
                        show-word-limit
                        rows="4"
                        v-model="invoiceForm.remark"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="附件" prop="attachList">
                  <VUpload :fileList="invoiceForm.attachList" />
                </el-form-item>
                <el-form-item >
                  <div style="text-align:right">
                    <el-button type="primary" @click="handleSaveInvoice" style="margin-right: 20px"
                    >确定</el-button
                  >
                  <el-button @click="invoiceShow = false">取消</el-button>
                  </div>

                </el-form-item>
              </el-form>
            </el-dialog>
          </div>
          <el-button
            type="primary"
            plain
            size="small"
            @click="addInvoice"
            style="margin: 20px 0"
            icon="el-icon-plus"
            v-if="permission"
          >
            新增
          </el-button>
          <el-table :data="invoice.records" v-loading="invoiceLoading" border>
            <el-table-column label="发票日期">
              <template slot-scope="scope">
                {{ scope.row.invoiceTime.replace('00:00:00', '') }}
              </template>
            </el-table-column>
            <el-table-column label="发票类型">
              <template slot-scope="scope">
                {{ invoiceTypeLavel(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column label="发票号码">
              <template slot-scope="scope">
                {{ scope.row.invoiceNo }}
              </template>
            </el-table-column>
            <el-table-column label="开票金额" align="right">
              <template slot-scope="scope">
                {{tool.money_format_allowvoid(scope.row.amount)}}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="invoice.total > 10"
            background
            layout="prev, pager, next , total"
            :total="invoice.total"
            @current-change="invoicePageChange"
          >
          </el-pagination>
        </el-tab-pane>
        <!-- 合同跟进tab4 -->
        <el-tab-pane label="合同验收及跟进事项" name="fourth">
          <FollowTask
            v-if="this.activeName == 'fourth'"
            v-show="contractId"
            :id="contractId"
            :contract="contract"
            :partnerList="partnerList"
            :permission="permission"
            @loadRecordList="loadRecordList"
          />
        </el-tab-pane>
        <el-tab-pane label="变更记录" name="five">
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="logRecordList"
            :page.sync="logRecordPage"

            ref="crud"
            @current-change="logRecordPagecurrentChange"
            @size-change="logRecordPagesizeChange"
            @on-load="loadRecordList"
            @refresh-change="loadRecordList">
        </avue-crud>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <!-- 侧边操作日志 -->
    <!-- <el-aside class="log" v-if="false">
      <div style="color: #f00">合同付款金额以财务金额为准，本系统只做参考</div>
      <p v-for="(item, index) in logRecordList" :key="index">
        {{ item.createTime + ' ' + item.content }}
      </p>
      <div style="height: 60px"></div>
      <div class="log-pagination">
        <el-pagination
          v-if="logRecordPage.total > 10"
          background
          layout="prev, pager, next , total"
          :total="logRecordPage.total"
          @current-change="logRecordPageChange"
          style=""
        >
        </el-pagination>
      </div>
    </el-aside> -->
  </el-container>
</template>

<script>
import {
  getPaymentStageList,
  savePaymentStage,
  removePaymentStage,
  updatePaymentStage,
  getPaymentRecordList,
  savePaymentRecord,
  contractStatistics,
  invoiceStatistics,
  getInvoiceList,
  saveInvoice,
  getContractDetail,
  getOperationRecordList,
  paymentrecordUpdate,
  paymentrecordRemove,
  paymentrecordDetail,
  paymentrecordImg
} from '@/api/crmedical/contract/execution';

import {
  getDictData,
  getPartnerList,
  getProjectList,
  userList,
  getBisDictData,
} from '@/api/crmedical/contract/add';

import FollowTask from './follow-task';
import VUpload from '@/views/components/v-upload.vue';

import { formatTime, showYmd } from '@/util/apputil';
import { vString, vMoney } from '@/util/validate';

import { Base64 } from 'js-base64';

export default {
  filters: {
    showYmd,
  },
  components: { FollowTask, VUpload },
  computed: {
    // 3个 key value 切换方法
    contractPaymentTypeLabel() {
      let res;
      this.dictData.paymentTypeList.forEach((item) => {
        if (item.dictKey == this.contract.paymentType) {
          res = item.dictValue;
        }
      });
      return res || '';
    },
    invoiceTypeLavel() {
      return function (key) {
        let res;
        this.dictData.invoiceType.forEach((item) => {
          if (item.dictKey == key) {
            res = item.dictValue;
          }
        });
        return res || '';
      };
    },
    contratLifeCycleLabel() {
      let dictItem = this.contractLifecycle.find((item) => {
        return item.dictKey == this.contract.lifecycleIndex;
      });
      return dictItem ? dictItem.dictValue : '';
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入小数点前9位后2位小数的金额'));
      }
    };
    return {
      contractPaymentTitle:'',
      collectionOperaterEdit:false,//收款记录编辑标识
       page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {

        page: true,
        border:true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu:false,
        column: [
           {
            label: '操作时间',
            prop: 'updateTime',
            format: 'yyyy-MM-dd  HH:mm:ss',
            type: 'date',
            width:"200"
          },
          {
            label: '操作人',
            prop: 'operator',
            width:"150"
          },
          {
            label: '操作内容',
            prop: 'operationContent',

          },
        ],
      },
      loading: false,
      // 合同详情
      contract: {
        destIdList: [], //关联合同列表
        fileList: [], //附件列表
      },
      // 日志list
      logRecordList: [],
      // 日志分页数据
      logRecordPage: {
         pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      partnerList: [], //合同对象列表
      projectList: [], //项目列表
      userTree: [], // 责任人列表
      // 字典
      dictData: {
        invoiceType: [], //发票类型字典
        paymentTypeList: [], //付款类型字典
        taxRateList: [], //税率字典
        contractLifecycle: [], //合同生命周期(状态)
      },
      // tabsName
      activeName: 'first',
      // 付款:
      paymentRecordShow: false,
      paymentRecordLoading: false,
      paymentRecord: {
        records: [],
        current: 1,
        total: 0,
      },
      form: {
        payAmount: '',
        payTime: '',
        remark: '',
        attachList: [],
      },
      formPaymentRules: {
        payAmount: [{ required: true, validator: validatePass, trigger: 'blur' }],
        payTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
      },
      // 合同阶段
      paymentStageShow: false,
      paymentStageLoading: false,
      paymentStageDialogTitle: '',
      paymentStage: {
        records: [],
        current: 1,
        total: 0,
      },
      //stage表单
      stageForm: {
        conditions: '',
        title: '',
        planAmount: '',
        planTime: '',
      },
      //stage表单校验
      stageFormRules: {
        title: [
          {
            required: true,
            validator: vString('名称', 1, 100),
            trigger: 'blur',
          },
        ],
        conditions: [
          {
            required: true,
            validator: vString('条件', 1, 200),
            trigger: 'blur',
          },
        ],
        planAmount: [{ required: true, validator: validatePass, trigger: 'blur' }],
        planTime: [{ required: true, message: '请选择时间', trigger: 'blur' }],
      },
      // 发票
      invoiceShow: false,
      invoiceLoading: false,
      invoice: {
        records: [],
        current: 1,
        total: 0,
      },
      invoiceForm: {
        amount: '',
        content: '',
        invoiceNo: '',
        remark: '',
        taxRate: '',
        type: '',
        attachList: [],
      },
      invoiceFormRules: {
        amount: [{ required: true, validator: validatePass, trigger: 'change' }],
        content: {
          required: true,
          validator: vString('发票内容', 1, 200),
          trigger: 'change',
        },
        invoiceNo: [
          {
            required: true,
            validator: vString('发票号码', 1, 200),
            trigger: 'change',
          },
        ],
        taxRate: [{ required: true, message: '请选择税率', trigger: 'change' }],
        type: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        invoiceTime: [{ required: true, message: '请选择日期', trigger: 'change' }],
      },
      // 合同金额统计
      statistics: {
        totalPaidAmount: '',
        totalPlanAmount: '',
        totalUnPaidAmount: '',
      },
      // 合同发票统计
      invoiceStatistics: {
        totalReceivedAmount: '',
        totalUnReceivedAmount: '',
      },
    };
  },
  props: ['contractId', 'permission', 'contractTypeList', 'lifeCycleList'],
  methods: {

    // onLoad(page) {
    //   page = page || this.page;
    //   this.loading = true;
    //  this.getOperationRecordList()
    // },
    logRecordPagecurrentChange(currentPage){
        this.logRecordPage.currentPage = currentPage
        console.log(this.logRecordPage)
    },
    logRecordPagesizeChange(pageSize){
      this.logRecordPage.pageSize = pageSize
      console.log(this.logRecordPage)
    },
    // 收款记录删除
    collectionRecordDel(row){
       this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           paymentrecordRemove(row.id).then(()=>{
          //更新收款记录表
          this.loadPaymentRecordList();
                this.loadContractStatistics();
                this.loadRecordList();
          this.$message({
              type: 'success',
              message: '删除成功!'
            });
          this.collectionOperaterEdit = false
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

    },
    // 收款记录编辑
    collectionRecordEdit(row){
      this.contractPaymentTitle = '编辑结算记录'
      console.log(row)
      paymentrecordDetail({id:row.id}).then(({data})=>{
        this.form = data
        paymentrecordImg({mainId:row.id}).then(({data})=>{
         this.form.attachList = data
         console.log("...........")
         console.log(this.form.attachList,data)
         this.loadPaymentRecordList();
                this.loadContractStatistics();
                this.loadRecordList();
          this.collectionOperaterEdit = true
          this.paymentRecordShow = true
        })

      })
    },
    addPaymentStage() {
      this.stageForm = {
        conditions: '',
        title: '',
        planAmount: '',
        planTime: '',
      };
      this.paymentStageDialogTitle = '新增计划';
      this.paymentStageShow = true;
    },
    // 页码切换
    paymentStagePageChange(val) {
      this.paymentStage.current = val;
      this.loadPaymentStageList();
    },
    addPaymentRecord() {
      this.contractPaymentTitle = '新增结算记录'
      this.paymentRecordShow = true;
      this.form = {
        payAmount: '',
        payTime: '',
        remark: '',
        attachList: [],
      };
    },
    paymentRecordPageChange(val) {
      this.paymentRecord.current = val;
      this.loadPaymentRecordList();
    },
    logRecordPageChange(val) {
      this.logRecordPage.current = val;
      this.loadRecordList();
    },
    addInvoice() {
      this.invoiceShow = true;
      console.log(this.contract.partnerId);
      this.invoiceForm = {
        amount: '',
        content: '',
        invoiceNo: '',
        remark: '',
        taxRate: '',
        type: '',
        attachList: [],
        partnerName: this.contract.partnerName,
        taxNo: this.contract.taxNo,
      };
    },
    invoicePageChange(val) {
      this.invoice.current = val;
      this.loadInvoiceList();
    },
    handleTabClick(tab, event) {
      console.log(tab);
    },
    // 新增付款=>确定
    onSubmit() {
      this.$refs.formPayment.validate((validateResult) => {
        if (!validateResult) {
          return false;
        } else {
          if(this.collectionOperaterEdit){


            let postData = this.form;
            postData.payTime = formatTime(this.form.payTime);
            postData.contractId = this.contractId;
            paymentrecordUpdate(postData).then((res) => {
              this.collectionOperaterEdit = false
              this.paymentRecordShow = false;
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: res.msg,
                });
                this.loadPaymentRecordList();
                this.loadContractStatistics();
                this.loadRecordList();
              }
            });
          }else{
            let postData = this.form;
            postData.payTime = formatTime(this.form.payTime);
            postData.contractId = this.contractId;
            savePaymentRecord(postData).then((res) => {
              this.paymentRecordShow = false;
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: res.msg,
                });
                this.loadPaymentRecordList();
                this.loadContractStatistics();
                this.loadRecordList();
              }
            });
          }
        }
      });
    },
    // 计划编辑弹窗
    editPaymentStage(item) {
      this.paymentStageDialogTitle = '编辑计划';
      this.paymentStageShow = true;
      this.stageForm = Object.assign({},item);
    },
    // 新增/编辑计划保存
    handleSavePaymentStage() {
      this.$refs.stageForm.validate((validateResult) => {
        if (!validateResult) {
          return false;
        } else {
          this.stageForm.planTime = formatTime(this.stageForm.planTime);
          this.stageForm.contractId = this.contractId;
          if (this.stageForm.id) {
            updatePaymentStage(this.stageForm).then((res) => {
              this.$message({
                type: 'success',
                message: res.msg,
              });
              this.paymentStageShow = false;
              // 清空数据
              this.stageForm = {
                conditions: '',
                title: '',
                planAmount: '',
                planTime: '',
              };
              this.loadPaymentStageList();
              this.loadContractStatistics();
              this.loadRecordList();
            });
          } else {
            savePaymentStage(this.stageForm).then((res) => {
              this.$message({
                type: 'success',
                message: res.msg,
              });
              this.paymentStageShow = false;
              // 清空数据
              this.stageForm = {
                conditions: '',
                title: '',
                planAmount: '',
                planTime: '',
              };
              this.loadPaymentStageList();
              this.loadContractStatistics();
              this.loadRecordList();
            });
          }
        }
      });
    },
    // 计划删除
    delPaymentStage(item) {
      let postData = new FormData();
      postData.append('ids', item.id);
      this.$confirm('确认删除？')
        .then((_) => {
          removePaymentStage(postData).then((res) => {
            this.$message({
              type: 'success',
              message: res.msg,
            });
            this.loadContractStatistics();
            this.loadPaymentStageList();
            this.loadRecordList();
          });
          done();
        })
        .catch((_) => {});
    },
    // 新增发票==>确定
    handleSaveInvoice() {
      this.$refs.invoiceForm.validate((validateResult) => {
        if (!validateResult) {
          return false;
        } else {
          let postData = this.invoiceForm;
          postData.invoiceTime = formatTime(this.invoiceForm.invoiceTime);
          postData.contractId = this.contractId;
          console.log('postData==>', postData);
          saveInvoice(postData).then((res) => {
            this.invoiceShow = false;
            this.$message({
              type: 'success',
              message: res.msg,
            });
            this.loadInvoiceList();
            this.loadInvoiceStatistics();
            this.loadRecordList();
          });
        }
      });
    },

    // 获取付款列表
    loadPaymentRecordList() {
      this.paymentRecordLoading = true;
      getPaymentRecordList({
        contractId: this.contractId,
        current: this.paymentRecord.current,
      }).then((res) => {
        this.paymentRecord = res.data;
        this.paymentRecordLoading = false;
      });
    },
    // 合同数据统计
    loadContractStatistics() {
      contractStatistics({ id: this.contractId }).then((res) => {
        console.log('contractStatistics==>', res.data);
        this.statistics = res.data;
      });
    },
    // 获取计划列表
    loadPaymentStageList() {
      this.paymentStageLoading = true;
      getPaymentStageList({
        contractId: this.contractId,
        current: this.paymentStage.current,
      }).then((res) => {
        this.paymentStage = res.data;
        this.paymentStageLoading = false;
      });
    },
    // 获取发票列表
    loadInvoiceList() {
      this.invoiceLoading = true;
      getInvoiceList({
        contractId: this.contractId,
        current: this.invoice.current,
      }).then((res) => {
        this.invoice = res.data;
        this.invoiceLoading = false;
      });
    },
    // 发票统计
    loadInvoiceStatistics() {
      invoiceStatistics({ id: this.contractId }).then((res) => {
        this.invoiceStatistics = res.data;
      });
    },
    formatNumber(str){
      let arr = str.split('：');
      let strs = '';
      if(arr.length<2){
        return str;
      }
      console.log(arr[arr.length-1]);
      console.log(arr);

      arr[arr.length-1] = this.tool.money_format_allowvoid(arr[arr.length-1]);
      arr.forEach((ele,index)=>{
        if(index!=0){
          strs=strs+'：'+ele;
        }else{
          strs=strs+ele;
        }
      });
      console.log(arr,strs);
      return strs;
    },
    // 获取日志
    loadRecordList() {
      let self = this;
      getOperationRecordList({
        contractId: this.contractId,
        current: this.logRecordPage.currentPage,
        size:this.logRecordPage.pageSize
      }).then((res) => {
        res.data.records.forEach((ele)=>{
          if(!ele.operationContent){
            ele.operationContent = '';
          }else{
            ele.operationContent = self.formatNumber(ele.operationContent);

          }
        });
        this.logRecordList = res.data.records;

        // this.page.total = res.data.total;
        this.logRecordPage.total = res.data.total;
      });
    },
  },
  created() {
    this.loading = true;
    console.log('this.contractId==>', this.contractId);
    getContractDetail({ id: this.contractId })
      .then((res) => {
        this.loading = false;
        console.log('asdsdsa',res.data)
        this.contract = res.data;
        // 富文本
        if (this.contract.content) {
          this.contract.content = Base64.decode(this.contract.content);
        }
        this.contract.type = String(this.contract.type);
        this.contract.paymentType = String(this.contract.paymentType);
        //2.1 ElementUi dateRange 需要数组
        let validityPeriodStart = new Date(this.contract.validityPeriodStart);
        let validityPeriodEnd = new Date(this.contract.validityPeriodEnd);
        this.contract.validityPeriod = [validityPeriodStart, validityPeriodEnd];
        //2.2 所选合同列表
        this.contract.destIdList.choosen = res.data.destIdList;
        //富文本编辑器bug
        this.contract.content = this.contract.content.replace(/&amp;nbsp;/gi, ' ');
        // 获取合同对象列表
        getPartnerList({ id: this.contract.projectId }).then((res) => {
          this.partnerList = res.data;
        });
        // 获取项目列表
        getProjectList().then((res) => {
          this.projectList = res.data;
        });
        // 获取项目税率字典
        getBisDictData({
          code: 'project_contract_invoice_tax_rate',
          projectId: this.contract.projectId,
        }).then((res) => {
          console.log('res getBisDictData==>', res);
          this.dictData.taxRateList = res.data;
        });
        // 责任人
        // userList({ projectId: this.contract.projectId }).then((res) => {
        //   this.userTree = res.data;
        // });
      })
      .catch((err) => {
        console.log('err==>', err);
        this.loading = false;
      });
    this.loadPaymentRecordList();
    this.loadPaymentStageList();
    this.loadInvoiceList();
    this.loadInvoiceStatistics();
    this.loadRecordList();
    this.loadContractStatistics();
    // 发票类型字典
    getDictData({ code: 'invoice_type' }).then((res) => {
      console.log(' res.data;==>', res.data);
      this.dictData.invoiceType = res.data;
    });
    // 付款类型
    getDictData({ code: 'contract_payment' }).then((res) => {
      this.dictData.paymentTypeList = res.data;
    });
    // getDictData({ code: 'contract_lifecycle' }).then((res) => {
    //   this.dictData.contractLifecycle = res.data;
    // });
  },
};
</script>

<style lang="scss" scoped>
.reminder{
  font-size: 12px;
  font-family: 'Microsoft YaHei UI';
  font-weight: 400;
  margin-top: 16px;
  color: #C0C4CC;
  float: right;
}
.gutter {
  height: 40px;
}
.form-item-width {
  width: 70%;
}
.pan {
  // display: flex;
  // justify-content: space-around;
  display: grid;
  grid-template-columns: repeat(5,1fr);
  background-color: #F2F6FC;
  border-radius: 4px;
  // padding: 10px;
  .pan-item {
    height: 88px;
    padding: 20px 0;
    display: flex;
    // justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    box-sizing: border-box;
    justify-content: center;
    .pan-item-content {
      width: 100%;
      // line-height: 40px;
      font-size: 18px;
      font-family:' Microsoft YaHei UI';
      font-weight: bold;
      color: #303133;
    }
    .pan-item-content-title{
      width: 100%;
      font-size: 14px;
      font-family: 'Microsoft YaHei UI';
      font-weight: 400;
      // line-height: 40px;
      color: #909399;
    }
    .pan-process {
      min-width: 150px;
      height: 40px;
      // display: flex;
      // align-items: center;
    }
  }
}
::v-deep .el-progress {
    width: 128px;
    // display: grid;
    // grid-template-columns: 2fr 1fr;
    // align-items: center;
    display: flex;
    align-items: center;
    height: 26.67px;
    position: relative;
}
// ::v-deep .el-progress {
//   display: flex;
// }
::v-deep .el-progress__text {
  font-size: 16px;
  font-family: 'Segoe UI';
  font-weight: 400;
  // margin-left: 0;
  color: #303133;


    width: 100px;
    position: absolute;
    // left: 55px;
    left: 50%;
    transform: translateX(25%);

}
::v-deep .el-progress-bar{
  padding-right: 0;
}
.plan {
  border-radius: 10px;
  padding: 10px;
  font-size: 18px;
  .plan-header {
    margin-top: 6px;
    margin-bottom: 16px;
    width: 90px;
    display: grid;
    grid-template-rows: 20px 40px;
    grid-row-gap: 16px;
  }
}
.log {
  position: relative;
  width: 200px;
  margin-left: 5px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  p {
    font-size: 15px;
    color: #666;
  }
  .log-pagination {
    position: absolute;
    bottom: 5px;
  }
}
#timeline-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}
.el-select-wide {
  width: 100%;
}
.top-title {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #efefef;
  padding-bottom: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  .name-code{
    display: flex;
    justify-content: space-between;
    width: 100%;
    .name-code-title{
      font-size: 18px;
      font-family: 'Microsoft YaHei UI';
      font-weight: 400;
      line-height: 32px;
      color: #303133;
    }
    .name-code-code{
      font-size: 14px;
      font-family: 'Microsoft YaHei UI';
      font-weight: 400;
      line-height: 32px;
      color: #909399;
    }
  }
}
</style>
